<template>
  <div role="row" @click="$emit('click')" :to="to" :is="tag" :class="['bcq-table-layout-row']">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'Row',
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    to: {
      type: String
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/row/row.vue